module.exports = "/_next/static/images/45fc6236674645efb0a6fadf6956223f-boy-looking-to-the-front-xs@1x.jpg";